import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
import { TableSelectStore } from "@/components/TableSelect/TableSelectStore";
import { DataTableStore } from "./DataTableStore";
import { SearchFilter } from "@/components/filters";
export class SingleChargingStationModelStore {
    constructor(chargingStationModelService, manufacturerService) {
        this.chargingStationModelService = chargingStationModelService;
        this.manufacturerService = manufacturerService;
        this.model = null;
        this.loading = false;
        this.manufacturerSelectStore = null;
        makeAutoObservable(this);
    }
    setModel(model) {
        this.model = model;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setManufacturerSelectStore(manufacturerSelectStore) {
        this.manufacturerSelectStore = manufacturerSelectStore;
    }
    async init(modelId) {
        this.setLoading(true);
        try {
            const models = modelId
                ? await this.chargingStationModelService.getModelsByIds([modelId])
                : null;
            this.setModel(models?.[0] || null);
            this.setManufacturerSelectStore(new TableSelectStore(new DataTableStore({
                dataLoader: {
                    loadData: (params) => this.manufacturerService.getManufacturersWithParams(params),
                },
            }), {
                dataLoader: () => this.model
                    ? this.manufacturerService.getManufacturersByIds([
                        this.model.idManufacturer,
                    ])
                    : Promise.resolve([]),
            }, [
                {
                    id: "manufacturer-search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию производителя...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.manufacturerSelectStore?.filterStore?.updateFilter("search", value),
                    },
                    visible: true,
                    order: 1,
                },
            ]));
        }
        catch (error) {
            onError(error, "Error initializing charging station model");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveModel(modelData) {
        try {
            this.setLoading(true);
            const task = this.model
                ? this.chargingStationModelService.updateModel(this.model.id, modelData)
                : this.chargingStationModelService.createModel(modelData);
            this.setModel(await task);
            return this.model;
        }
        catch (error) {
            onError(error, "Error saving charging station model");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteModel(modelId) {
        this.setLoading(true);
        try {
            await this.chargingStationModelService.deleteModel(modelId);
            this.setModel(null);
        }
        catch (error) {
            onError(error, "Failed to delete charging station model");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearModelData() {
        this.setModel(null);
        this.manufacturerSelectStore?.reset();
        this.setLoading(false);
    }
}
